<template>
  <div class="wrapper" :class="{ hide: !show }" :style="wrapperStyle" data-flex="dir:top main:center cross:center">
    <div data-flex-box="0">
      <div class="yuan" data-flex="main:center cross:center">
        <i class="mg-icon mg-icon-info-circle-fill" data-flex-box="0"></i>
      </div>
      <div class="tips" v-html="tips"></div>
      <div class="btns" data-flex="main:center cross:center" @click="btnClick">
        <i data-flex-box="0">{{ btnText }}</i>
      </div>
    </div>
  </div>
</template>

<script>
import customEvents from '@/config/custom_events'
import bus from '@/libs/bus'
import { getRandomString } from '@/utils/string'
import { getWindowHeight } from '@/utils/common'

const defaultBtnText = '我知道了'
const defaultZIndex = 8888

// noinspection JSUnusedGlobalSymbols
export default {
  name: 'MgAlert',
  data() {
    return {
      windowHeight: 667,
      show: false,
      tips: '',
      btnText: defaultBtnText,
      btnCallback: null,
      zIndex: defaultZIndex
    }
  },
  computed: {
    wrapperStyle() {
      return {
        height: `${this.windowHeight}px`,
        zIndex: this.zIndex
      }
    }
  },
  methods: {
    btnClick() {
      this.show = false
      document.getElementById('app').dataset.dialogId = ''

      if (!this.btnCallback) {
        return
      }

      this.$nextTick(() => this.btnCallback())
    }
  },
  created() {
    this.windowHeight = getWindowHeight()
  },
  mounted() {
    bus.$on(customEvents['AlertDialog.show'], (message = {}) => {
      const el = document.getElementById('app')
      const id = el.dataset.dialogId

      if (id) {
        return
      }

      const { tips, btnText, btnCallback, zIndex } = message

      if (!tips) {
        return
      }

      this.show = true
      this.tips = tips
      this.btnText = btnText || defaultBtnText
      this.btnCallback = btnCallback || null
      this.zIndex = zIndex || defaultZIndex
      el.dataset.dialogId = getRandomString(8, 2)
    })
  }
}
</script>

<style lang="less" scoped>
.wrapper {
  width: 100%;
  background: rgba(37, 38, 45, .4);
  position: fixed;
  top: 0;

  &.hide {
    display: none;
  }

  >div {
    width: 600px;
    max-height: 1200px;
    background: #fff;
    border-radius: 12px;
    overflow: hidden;
  }

  .yuan {
    width: 128px;
    height: 128px;
    background: #f3f4f5;
    border-radius: 50%;
    margin: 0 auto;
    margin-top: 40px;
    overflow: hidden;

    >i {
      font-size: 42px;
      font-style: normal;
      color: #666;
    }
  }

  .tips {
    font-size: 14px;
    color: #666;
    line-height: 1.4;
    padding: 10px 20px 40px 10px;
    text-align: center;
  }

  .btns {
    height: 100px;
    background: #f3f3f3;
    border-top: 1px solid #d3d3d3;
    /* px-to-viewport-ignore */

    >i {
      font-size: 16px;
      font-style: normal;
      color: #fc962d;
    }
  }
}
</style>